$(function() {
  function animationInit() {

    var coll = document.getElementsByClassName("collapsible");
    let i;

    for (i = 0; i < coll.length; i++) {
      coll[i].addEventListener("click", function() {
        this.classList.toggle("active");
        var content = this.nextElementSibling;
        if (content.style.display === "block") {
          content.style.display = "none";
        } else {
          content.style.display = "block";
        }
      });
    }

    let title = document.getElementById('home-hero-text');
    let sltxTxt = document.getElementById('sltx-txt');
    // let forecastAnimaiton = document.getElementById('forecast');
    let heroAction = document.querySelector('.hero-actions');
    let productSlider = document.querySelector('.ftr-products-collections');
    let homeProductHeading = document.getElementById('home-product-heading');
    let diaries = document.querySelector('.diaries-content-big');
    let diariesHeader = document.querySelector('.diaries-header');
    let raincoatCover1 = document.querySelector('.rnct-content-cover');
    let raincoatCover2 = document.querySelector('.rnct-content-cover-2');
    let featuresListItem = document.querySelectorAll('.features-list-item');
    let companyShowcase = document.querySelector('.company-showcase');

    if (featuresListItem && featuresListItem.length > 0) {
      featuresListItem = Array.prototype.slice.call(featuresListItem);
    }

    const options = {
      rootMargin: '-130px 0px'
    }

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        // console.log('entry', entry)
        if (!entry.isIntersecting) return;

      
        if (entry.target == sltxTxt) {
          sltxTxt.classList.add('fade-in')
        }

        // if (entry.target == forecastAnimaiton && entry.isIntersecting) {
        //   forecastAnimaiton.classList.add('fadein-left-start')
        // }

        if (entry.target == homeProductHeading && entry.isIntersecting) {
          homeProductHeading.classList.add('fadein-bottom-start')
        } 

        if (entry.target == productSlider && entry.isIntersecting) {
          productSlider.classList.add('fadein-left-start')
        } 

        if (entry.target == diaries && entry.isIntersecting) {
          diaries.classList.add('fadein-left-start')
        } 

        if (entry.target == companyShowcase && entry.isIntersecting) {
          companyShowcase.classList.add('fadein-left-start')
        } 

        if (entry.target == diariesHeader && entry.isIntersecting) {
          diariesHeader.classList.add('fadein-bottom-start')
        } 

        if (entry.target == raincoatCover1 && entry.isIntersecting) {
          raincoatCover1.classList.add('w-0')
        } 

        if (entry.target == raincoatCover2 && entry.isIntersecting) {
          raincoatCover2.classList.add('w-0')
        } 

        entry.target.classList.add('fadein-bottom-start')

        // if (entry.target == heroAction && entry.isIntersecting) {
        //   heroAction.classList.add('fadein-bottom-init')
        // } else {
        //   heroAction.classList.remove('fadein-bottom-init')
        // }

        observer.unobserve(entry.target)
      })
    }, options)

    if (title) {
      observer.observe(title);
    }

    // if (forecastAnimaiton) {
    //   observer.observe(forecastAnimaiton);
    // }

    if (heroAction) {
      observer.observe(heroAction);
    }

    if (homeProductHeading) {
      observer.observe(homeProductHeading)
    }

    if (productSlider) {
      observer.observe(productSlider)
    }

    if (diaries) {
      observer.observe(diaries)
    
    }
    if (diariesHeader) {
      observer.observe(diariesHeader)
    }
    if (raincoatCover1) {
      observer.observe(raincoatCover1)
    }

    if (raincoatCover2) {
      observer.observe(raincoatCover2)
    }

    if (companyShowcase) {
      observer.observe(companyShowcase)
    }

    let hasClass = document.getElementsByClassName('fadein-bottom-init');
    if (hasClass.length > 0) {
      heroAction.classList.remove('fadein-bottom-init')
    }

    if (featuresListItem && featuresListItem.length > 0) {
      featuresListItem.forEach(item => {
        observer.observe(item);
      })
    }


  }

  animationInit();

  
  var windowWidth; 

  $(window).resize(function () {
    windowWidth = $(window).width();
    
  });


  // scroll 

  let rain = document.querySelector('.rain-image');
  let pl3Path = document.querySelector('.hero');

  (scrollPlaneAnimation3 = function () {
    let y = window.scrollY;

    if (window.innerWidth > 960) {
      rain.style.transform = `translateX(${y / 16}px)`;
    } else {
      rain.style.transform = `translateX(-${y / 16}px)`;
    }

  })();


  window.addEventListener('scroll', scrollPlaneAnimation3);
});

console.log(document.querySelector('.forecast'));

//weather
// var dict = {
//   '01d': 'wi-day-sunny',
//   '02d': 'wi-day-cloudy',
//   '03d': 'wi-cloud',
//   '04d': 'wi-cloudy',
//   '09d': 'wi-showers',
//   '10d': 'wi-day-rain-mix',
//   '11d': 'wi-thunderstorm',
//   '13d': 'wi-snow',
//   '50d': 'wi-fog',
//   '01n': 'wi-night-clear',
//   '02n': 'wi-night-alt-cloudy',
//   '03n': 'wi-night-alt-cloudy-high',
//   '04n': 'wi-cloudy',
//   '09n': 'wi-night-alt-sprinkle',
//   '10n': 'wi-night-alt-showers',
//   '11n': 'wi-night-alt-thunderstorm',
//   '13n': 'wi-night-alt-snow',
//   '50n': 'wi-night-fog'
// };

// if (navigator.geolocation) {
//   navigator.geolocation.getCurrentPosition(function (position) {
//     weatherApp(position.coords.latitude, position.coords.longitude);
//   }, function() {
//     $('#forecast').css('display', 'none');
//   })
// } else {
//   $('#forecast').css('display', 'none');
//   console.log('error-on-ios');
// }


// let foreCastDays = document.getElementsByClassName('forecast-day')

// function weatherApp(lat, lon) {
//   const settings = {
//     "async": true,
//     "crossDomain": true,
//     "url": `https://community-open-weather-map.p.rapidapi.com/forecast/daily?lat=${lat}&lon=${lon}&cnt=5&units=metric%20or%20imperial`,
//     "method": "GET",
//     "headers": {
//       "x-rapidapi-key": "5393b41cdbmshc63a38aac052117p10bd81jsn8875d991d154",
//       "x-rapidapi-host": "community-open-weather-map.p.rapidapi.com"
//     }
//   };

//   $.ajax(settings).done(function (response) {
//     document.getElementById('city-w').innerText = response.city.name;
//     console.log(response)
//     response.list.forEach((day, index) => {
//       ShowDay(day.dt, index, day.weather[0].icon);
//     })
//   });
// }


// function ShowDay(day, index, icon) {
//   let dayP = document.getElementById(`forecast-day-${index+1}`);
//   var allDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
//   var d = new Date(day * 1000); // to get the DateTime. 
//   var dayName = allDays[d.getDay()]; // It will give day index, and based on index we can get day name from the array. 
//   dayP.innerText = dayName;
//   // console.log($('#forecast-img-' + (index + 1)))
//   // $('#forecast-img-' + (index + 1)).attr("src", `http://openweathermap.org/img/wn/${icon}@2x.png`);
//   $(`#forecast-icon-${index + 1}`).append(`<i class="wi ${dict[icon]}"></i>`);
//   // console.log($(`#forecast-icon-${index + 1}`))

// }

